// inertiaErrorHandler.ts
import { router } from '@inertiajs/vue3';
import { App } from 'vue';
import { sidebarDrawer } from '@/Composables/PageMeta';



export const setupInertiaErrorHandler = (app: App) => {
    
    router.on('error', (errors: any) => {
        // console.log('errors', errors)
    });
    router.on('invalid', (event) => {
        // console.log('invalid', event)
        // event.preventDefault()
    
    });
    router.on('navigate', (event) => {
        // console.log('navigate', event)
    });
};